<div class="kw-page" [nbSpinner]="this.isLoading || this.filterService.isLoading">

  <div class="kw-page-header">
    <div class="title-block">
      <h2 class="page-title">Inventory Summary</h2>
      <span class="page-subtitle">Review on-hand inventory across products, locations, and lots</span>
    </div>
    <div class="header-actions">
      <button mat-stroked-button class="header-btn" (click)="scan()">
        <fa-icon [icon]="faQrcode" class="me-2"></fa-icon>Scan
      </button>
      <button *ngIf="this.authService.hasRole('hollingbery:ar-user')" mat-stroked-button class="header-btn" (click)="moveBulkHUM()">
        <fa-icon [icon]="faLongArrowAltRight" class="me-2"></fa-icon>Move Multiple
      </button>
      <button *ngIf="this.authService.hasRole('hollingbery:ar-user')" mat-stroked-button class="header-btn" (click)="createHUM()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>Create One
      </button>
      <button mat-raised-button color="primary" class="header-btn primary-btn" (click)="createBulkHUM()">
        <fa-icon [icon]="faPlus" class="me-2"></fa-icon>{{this.authService.hasRole('hollingbery:ar-user') ? "Create Multiple" : "Create Inventory"}}
      </button>
    </div>
  </div>

  <div class="filters-bar">
    <kw-filter-dropdown class="filter-widget" [filterSettings]="this.dropdownSettings"
      [gridCountDataAndMessage]="gridMessageAndCount"
      (filterResultsChange)="setFilterResults($event)"
      (downloadFiles)="downloadFiles($event)">
    </kw-filter-dropdown>
  </div>

  <div class="grid-card" [hidden]="tableData.length === 0">
    <ejs-grid #grid id="grid" *ngIf="!this.isLoading && !this.filterService.isLoading" [dataSource]="this.tableData" [filterSettings]='this.filterSettings' [enableStickyHeader]="true"
      [allowExcelExport]='true' [allowPdfExport]='true' [allowPaging]="true" [allowGrouping]='true'
      [pageSettings]="this.pageSettings" [allowFiltering]="true" [groupSettings]="this.groupOptions"
      [allowSorting]='true' [columns]="this.displayedColumns" [allowTextWrap]="true">
    </ejs-grid>
  </div>

  <!-- Mobile card list: replaces the data grid on small screens -->
  <div class="kw-mobile-list">
    <div class="m-card" *ngFor="let c of mobileCards | slice:0:mobileVisibleCount; trackBy: trackByCard" (click)="openDialog(c)">
      <div class="m-card-top">
        <span class="m-card-name">{{c.barcode}}</span>
        <span class="status-tag" *ngIf="c.statusName" [ngClass]="getStatusClass(c.statusName)"><span class="status-dot"></span>{{c.statusName}}</span>
      </div>

      <div class="m-card-meta">
        <div class="m-meta-line" *ngIf="c.productName">
          <fa-icon [icon]="faBox" class="m-meta-icon"></fa-icon>{{c.productName}}
        </div>
        <div class="m-meta-sub" *ngIf="c.extraItemCount">+{{c.extraItemCount}} more item{{c.extraItemCount > 1 ? 's' : ''}}</div>
        <div class="m-meta-line" *ngIf="c.lotNumber">
          <fa-icon [icon]="faTag" class="m-meta-icon"></fa-icon>Lot {{c.lotNumber}}<ng-container *ngIf="c.alphaLotAttribute"> · Alpha {{c.alphaLotAttribute}}</ng-container>
        </div>
        <div class="m-meta-line" *ngIf="c.orderNumber">
          <fa-icon [icon]="faFileInvoice" class="m-meta-icon"></fa-icon>Order {{c.orderNumber}}
        </div>
      </div>

      <div class="m-card-foot">
        <span class="type-pill">{{c.quantity | number}} · {{c.weight | number}} lb</span>
        <span class="m-card-note" *ngIf="c.createdDate">{{c.createdDate | date:'MM/dd/yyyy'}}</span>
        <div class="m-card-actions">
          <button mat-icon-button aria-label="Open handling unit" (click)="openDialog(c); $event.stopPropagation()">
            <fa-icon [icon]="faChevronRight"></fa-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="m-empty" *ngIf="!mobileCards.length && !this.isLoading">
      <fa-icon [icon]="faBoxes" class="m-empty-icon"></fa-icon>
      <div>No inventory matches your filters</div>
    </div>

    <button class="m-show-more" *ngIf="mobileCards.length > mobileVisibleCount"
            mat-stroked-button (click)="showMoreMobile()">
      Show more ({{mobileCards.length - mobileVisibleCount}} remaining)
    </button>
  </div>

</div>

<ng-template #actionTemplate let-data>
  <div class="row-actions">
    <button mat-icon-button aria-label="Open handling unit" (click)="openDialog(data)">
      <fa-icon [icon]="faChevronRight"></fa-icon>
    </button>
  </div>
</ng-template>

<ng-template #statusTemplate let-data>
  <span class="status-tag" *ngIf="data.inventoryStatusName" [ngClass]="getStatusClass(data.inventoryStatusName)">
    <span class="status-dot"></span>{{ data.inventoryStatusName }}
  </span>
</ng-template>
